import React from "react";
import ModalHeader from "@/customComponents/uiComponents/modal/ModalHeader.jsx";
import {flightDelayIcon, infinityIcon} from "@img/index.js";

export function FlightDelayed({setStep, closeModal, previousStep}) {
    const backStep = previousStep || "bookingReceived";
    return (
        <>
            <ModalHeader title="" extraClasses="" totalSteps={0} cancelButton={false} cancelButtonType="icon" backStep={backStep} showBackButton={true} setStep={setStep} closeModal={closeModal}/>
            <div className="hopn-airport-perks modalPages-spacing pb-8">
                <div className="hopn-perks-highlight">
                    <h5>Flight Delayed? No Problem:</h5>
                    <div className="hopn-perks-highlight-item">
                        <img src={flightDelayIcon} alt="Flight Delay"/>
                        <span>Hop'n tracks your flight and adjusts your pickup time automatically. Whether it's a flight delay or baggage hold-up, we've got you covered. Simply choose "By flight arrival" and let your navigator ensure a smooth pickup experience</span>
                    </div>
                </div>
                <div className="hopn-perks-highlight second">
                    <h5>Lost baggage or delays</h5>
                    <div className="hopn-perks-highlight-item">
                        <img src={infinityIcon} alt="Unlimited Wait"/>
                        <span>Lost baggage? Customs or immigration delays? No worries—your driver will wait as long as needed</span>
                    </div>
                </div>
            </div>
        </>
    );
}
export default FlightDelayed;
